import React from 'react';
import InternalMenu from '../../components/shared/InternalMenu';

/**
 * View component for the Documentation page
 * 
 * @param {Object} props
 * @param {string} props.activeSection - Currently active section ID
 * @param {Function} props.setActiveSection - Function to set the active section
 * @param {Object} props.sections - Documentation sections data
 * @param {Array} props.sidebarItems - Items for the sidebar navigation
 * @returns {JSX.Element}
 */
const DocumentationPageView = ({ 
  activeSection, 
  setActiveSection, 
  sections, 
  sidebarItems 
}) => {
  return (
    <div className="min-h-screen bg-black">
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 w-full">
        <div className="max-w-6xl mx-auto text-center py-16 px-4">
          <h1 className="text-4xl font-bold text-white mb-2">Documentation</h1>
          <p className="text-teal-100 max-w-2xl mx-auto">
            No complex documentation needed - just drag, drop, and we'll handle the rest
          </p>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 py-12 lg:flex lg:gap-12">
        {/* Using the reusable internal menu component */}
        <InternalMenu 
          items={sidebarItems}
          activeItemId={activeSection}
          onItemClick={setActiveSection}
        />

        {/* Main content */}
        <main className="flex-1 bg-gray-900 rounded-lg border border-gray-800 p-8">
          {sections[activeSection].content}
        </main>
      </div>
    </div>
  );
};

export default DocumentationPageView; 